"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8805 3.4927h6.7172l2.2391 2.239-1.4913 1.866H17.226L16.1065 6.478l-1.1196 1.1196-1.1195-1.1196-1.1195 1.1196h-1.6203c-.6452 1.1154-1.8512 1.8659-3.2325 1.8659-2.061 0-3.7318-1.6708-3.7318-3.7318S5.8341 2 7.8951 2c1.2209 0 2.3046.5863 2.9854 1.4927zM7.8879 6.7305c.5523 0 1-.4478 1-1 0-.5523-.4477-1-1-1s-1 .4477-1 1c0 .5522.4477 1 1 1zM10.446 10h3.1085l2.4975 3.9961h5.3356l-1.9828 5.9487a3.0001 3.0001 0 0 1-2.8461 2.0513h-9.117a3 3 0 0 1-2.846-2.0513l-1.983-5.9487h5.3357L10.446 10zm2 2 1.2475 1.9961h-3.3866L11.5545 12h.8915zm-7.0584 3.9961 1.1055 3.3162a1 1 0 0 0 .9486.6838h9.117a1 1 0 0 0 .9487-.6838l1.1054-3.3162H5.3876z"
  })];
};

exports.default = _default;